/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {AssetVehicleIcon} from '../icons/AssetVehicleIcon';
import {GroupChooserIcon} from '../icons/current/GroupChooserIcon';
import Render from '../render/Render';
import {dlsColor} from '../theme/theme';
import {IconSize} from '../types/types';

export interface FilterTreeNodeIconProps {
  isAsset: boolean;
}

/**
 * Renders the icon shared by tree checklist node rows and search result
 * rows - an asset icon when `isAsset`, otherwise a group icon.
 *
 * ```typescript
 * import FilterTreeNodeIcon from '@ion/dls/src/filters/FilterTreeNodeIcon';
 *
 * ...
 *
 * <FilterTreeNodeIcon isAsset={node.type === 'asset'} />
 * ```
 */
export const FilterTreeNodeIcon = ({isAsset}: FilterTreeNodeIconProps) => (
  <Render>
    <Render.If condition={isAsset}>
      <AssetVehicleIcon size={IconSize.large} color={dlsColor('grey1') as any} />
    </Render.If>
    <Render.Else>
      <GroupChooserIcon size={IconSize.medium} color={dlsColor('grey1') as any} />
    </Render.Else>
  </Render>
);

export default FilterTreeNodeIcon;
